exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3-7jdtXGk4-IHrW24dLF4t {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_3-7jdtXGk4-IHrW24dLF4t"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/PlayButton/styles.scss
// module id = 48
// module chunks = 0